export const throwShipmentError = (error: unknown) => {
  let errorMessage = 'Error fetching shipment details';
  let cause: unknown;

  if (error instanceof Error) {
    cause = error.cause;
    errorMessage += `: ${error.message}`;
  }

  throw new Error(errorMessage, { cause });
}